import { DashboardIFrame } from "components/organisms/DashboardIFrame";

const Performance = () => {
  return <DashboardIFrame page="performance" />;
};

export { Performance };
